import Timebar from './Timebar';
import OverlayInstructions from './OverlayInstructions';
import OverlaySummary from './OverlaySummary';
import Hud from 'app/ui/hud/Hud';

import { FONT_TITLE, FONT_COPY } from 'app/constants/AppConstants';

export default class GameHud extends Phaser.Group {
  constructor(game) {
    super(game);

    // score panel
    this.scorePanel = this.game.make.image(0, 30, 'foodgame_gui', 'score_panel.png');
    this.addChild(this.scorePanel);
    this.scoreLabel = this.game.make.text(73, 73, 0, {
      font: '75px ' + this.game.titleFontStyle,
      fill: '#ffffff',
      wordWrap: true,
      wordWrapWidth: 360,
    });
    this.scoreLabel.anchor.set(0.5);
    this.scoreLabel.angle = -6;
    this.scorePanel.addChild(this.scoreLabel);

    // timebar
    this.timebar = new Timebar(this.game);
    this.timebar.y = 640;
    this.addChild(this.timebar);

    //
    this.setTime(1);
    this.setScore(0);

    //
    this.game.scale.onSizeChange.add(this.positionElements, this);
    this.positionElements();

    // general hud
    this.genericHud = new Hud(this.game, Hud.MINIGAME);
    this.game.add.existing(this.genericHud);
  }

  positionElements() {
    this.x = this.game.width / 2;
    this.scorePanel.x = -this.game.width / 2 + this.game.screenPaddingX;

    this.timebar.x = -this.timebar.bg.width / 2;

    //
    if (this.overlayInstructions) {
      this.overlayInstructions.x = (this.game.width - this.game.defaultWidth) / 2;
    }

    //
    if (this.overlaySummary) {
      this.overlaySummary.x = (this.game.width - this.game.defaultWidth) / 2;
    }
  }

  setScore(value) {
    this.scoreLabel.text = value;
  }

  setTime(value) {
    this.timebar.setValue(value);
  }

  showInstructions() {
    this.overlayInstructions = new OverlayInstructions(this.game);
    this.overlayInstructions.onClose.add(this.handleInstructionsClose, this);
    this.game.add.existing(this.overlayInstructions);
    this.game.world.bringToTop(this.genericHud);
    this.positionElements();
  }

  handleInstructionsClose() {
    this.overlayInstructions.destroy();
    this.overlayInstructions = null;
  }

  showSummary(score) {
    this.overlaySummary = new OverlaySummary(this.game, score, this.genericHud);
    this.game.add.existing(this.overlaySummary);
    this.game.world.bringToTop(this.genericHud);
    this.positionElements();
  }

  destroy() {
    this.genericHud.destroy();
    this.game.scale.onSizeChange.remove(this.positionElements, this);
    super.destroy();
  }
}



// WEBPACK FOOTER //
// ./js/app/games/food/ui/GameHud.js